// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"36b09f14","487":"c516dfac","766":"cfb0ff32"}[chunkId] + ".chunk.js";
};